export default [{
    text: 'Прямая аренда',
    value: 'direct',
}, {
    text: 'Субаренда',
    value: 'sublease',
}, {
    text: 'Договор совместной деятельности',
    value: 'jointVenture',
}];
